import Vue from 'vue';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
// element

// element 多语言缺少 ar
import locale from 'element-ui/lib/locale'
import arLocale from './el/ar'
import enLocale from './el/en'
import zhLocale from './el/zh-CN'
import deLocale from './el/de'
import esLocale from './el/es'
import frLocale from './el/fr'
import hiLocale from './el/hi'
import idLocale from './el/id'
import itLocale from './el/it'
import jaLocale from './el/ja'
import koLocale from './el/ko'
import ptLocale from './el/pt'
import ruLocale from './el/ru-RU'
import thLocale from './el/th'
import trLocale from './el/tr-TR'
import viLocale from './el/vi'
import zhHKLocale from './el/zh-TW'

// 引入各个语言配置文件
import ar from './lang/ar';
import de from './lang/de';
import en from './lang/en';
import es from './lang/es';
import fr from './lang/fr';
import hi from './lang/hi';
import id from './lang/id';
import it from './lang/it';
import ja from './lang/ja';
import ko from './lang/ko';
import pt from './lang/pt';
import ru from './lang/ru';
import th from './lang/th';
import tr from './lang/tr';
import vi from './lang/vi';
import zh_rhk from './lang/zh_rhk';
import zh from './lang/zh';

const messages = {
    ar:{...ar,...arLocale},
    de:{...de,...deLocale},
    en:{...en,...enLocale},
    es:{...es,...esLocale},
    fr:{...fr,...frLocale},
    hi:{...hi,...hiLocale},
    id:{...id,...idLocale},
    it:{...it,...itLocale},
    ja:{...ja,...jaLocale},
    ko:{...ko,...koLocale},
    pt:{...pt,...ptLocale},
    ru:{...ru,...ruLocale},
    th:{...th,...thLocale},
    tr:{...tr,...trLocale},
    vi:{...vi,...viLocale},
    'zh-rHK':{...zh_rhk,...zhHKLocale},
    zh:{...zh,...zhLocale},
}
console.log(messages.en)
// 创建vue-i18n实例i18n
let lang=localStorage.getItem('localeLang') || 'en';
const i18n = new VueI18n({
    // 设置默认语言
    locale: lang,
    messages:messages
})
locale.use(Element,{
    i18n:(key,value)=>i18n.t(key,value)
})
// 暴露i18n
export {i18n,messages};


// WEBPACK FOOTER //
// ./src/i18n/index.js